package com.myfield.app.util

import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.radialGradient
import com.varabyte.kobweb.compose.ui.graphics.Colors
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba


enum class Theme(
    val rgb: CSSColorValue
) {
    Primary(rgb = rgb(r = 195, g = 255, b = 0)),
    Secondary(rgb = rgb(r = 195, g = 255, b = 0)),
    Background(rgb = rgba(r = 4, g = 7, b = 39, a = 1f)),
    Text(rgb = rgb(r = 255, g = 255, b = 255)),
    TextLowVisibility(rgb = rgba(r = 255, g = 255, b = 255, a = 0.5f)),
}

val TextGradient = linearGradient(
    dir = LinearGradient.Direction.ToRight,
    from = Theme.Secondary.rgb,
    to = Colors.White
)

val BackgroundGradient = radialGradient(
    from = rgb(r = 25, g = 43, b = 124),
    to = rgb(r = 4, g = 7, b = 39)
)